<header class="aca-shell-header" role="banner">
  <div class="aca-shell-header__brand">
    <!-- The shipped asset is a coloured mark followed by an upper-case wordmark,
         so only the mark is shown — the box is clipped to its width — and the
         name is set beside it, as the reference has it. A logo an administrator
         uploaded is shown whole: it is not that asset and nothing about it can
         be assumed. -->
    <a class="aca-shell-header__logo" [routerLink]="landingPage" [attr.aria-label]="branding.name()">
      <span class="aca-shell-header__logomark" [class.aca-shell-header__logomark--custom]="branding.customLogo()">
        <img [src]="branding.logo()" alt="" aria-hidden="true" />
      </span>
      <span class="aca-shell-header__logoname">{{ branding.name() }}</span>
    </a>

    <button
      type="button"
      class="aca-shell-header__menu"
      mat-icon-button
      (click)="toggleMenu()"
      [attr.aria-expanded]="!navCollapsed"
      [attr.aria-label]="'APP.TOOLTIPS.COLLAPSE_NAVIGATION' | translate"
    >
      <mat-icon>menu</mat-icon>
    </button>
  </div>

  <form class="aca-shell-header__search" (submit)="onSearchSubmit($event)" role="search">
    <mat-icon class="aca-shell-header__searchicon" aria-hidden="true">search</mat-icon>
    <input
      type="text"
      name="q"
      class="aca-shell-header__input"
      [(ngModel)]="searchTerm"
      [placeholder]="'SEARCH.INPUT.PLACEHOLDER' | translate"
      [attr.aria-label]="'SEARCH.INPUT.ARIA-LABEL' | translate"
      autocomplete="off"
    />
    <!-- the reference shows no button in the field; Enter submits, and this
         keeps a real submit control for anyone driving the form by keyboard
         or screen reader -->
    <button type="submit" class="aca-shell-header__submit">{{ 'SEARCH.BUTTON.TOOLTIP' | translate }}</button>
  </form>

  <div class="aca-shell-header__actions">
    <!-- on a phone there is no room for the field: the search page has its own -->
    <a
      class="aca-shell-header__searchbtn"
      routerLink="/document-search"
      [matTooltip]="'SEARCH.BUTTON.TOOLTIP' | translate"
      [attr.aria-label]="'SEARCH.BUTTON.TOOLTIP' | translate"
    >
      <mat-icon>search</mat-icon>
    </a>

    <app-notifications />

    <aca-toolbar class="aca-shell-header__ext" [items]="actions" *ngIf="actions?.length" />

    <button
      type="button"
      class="aca-shell-header__help"
      [class.aca-shell-header__help--news]="whatsNew.unseen()"
      [matMenuTriggerFor]="helpMenu"
      [matTooltip]="'DMS.SHELL.HELP' | translate"
      [attr.aria-label]="(whatsNew.unseen() ? 'DMS.SHELL.HELP_NEWS' : 'DMS.SHELL.HELP') | translate"
    >
      <mat-icon>help_outline</mat-icon>
    </button>
    <mat-menu #helpMenu="matMenu" class="aca-help-menu" xPosition="before">
      <button mat-menu-item (click)="startTour()">
        <mat-icon>tour</mat-icon><span>{{ 'DMS.SHELL.HELP_TOUR' | translate }}</span>
      </button>
      <button mat-menu-item (click)="palette.open()">
        <mat-icon>keyboard_command_key</mat-icon><span>{{ 'DMS.SHELL.HELP_PALETTE' | translate }}</span>
        <kbd class="aca-help-menu__kbd">Ctrl K</kbd>
      </button>
      <button mat-menu-item (click)="whatsNew.open()">
        <mat-icon>auto_awesome</mat-icon><span>{{ 'DMS.SHELL.HELP_WHATS_NEW' | translate }}</span>
        <span class="aca-help-menu__new" *ngIf="whatsNew.unseen()">{{ 'DMS.SHELL.HELP_NEW' | translate }}</span>
      </button>
      <a mat-menu-item [href]="helpUrl" target="_blank" rel="noopener">
        <mat-icon>open_in_new</mat-icon><span>{{ 'DMS.SHELL.HELP_MANUAL' | translate }}</span>
      </a>
    </mat-menu>

    <app-profile-menu />
  </div>
</header>
